<template>
    <div class="main">
        <div class="link_title">
            联系我们
        </div>
        <div class="address">
            <div class="ad_text">{{ SITE_BTN_CONFIG.kefu_url.btn_value }}</div>
            <div class="copy_btn" @click="copyText(SITE_BTN_CONFIG.kefu_url.btn_value)">复制</div>
        </div>
        <div class="open_web">请复制上方链接在手机<span @click.stop="openBrowser">浏览器</span>内打开</div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                SITE_BTN_CONFIG:SITE_BTN_CONFIG,
            }
        },
        methods:{
            copyText(text){
                const input = document.createElement('input');
                input.value = text;
                document.body.appendChild(input);
                input.select();
                document.execCommand('copy');
                document.body.removeChild(input);
                this.$message.success('复制成功！');
            },
            openBrowser(){
                // window.open(this.SITE_BTN_CONFIG.kefu_url.btn_value);
            },
        }
    }
</script>

<style lang="scss" scoped>
.main{
    width: 100%;
    height: 100vh;
    background: #fff;
    text-align: center;
    .link_title{
        font-size: 24px;
        font-weight: bold;
        color: #000;
        padding: 60px 0;
    }
    .address{
        width: calc(100% - 30px);
        height: 55px;
        border: 1px solid #ccc;
        border-radius: 6px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 5px;
        .ad_text{
            font-size: 14px;
            color: #ccc;
            width: calc(100% - 85px);
            overflow: hidden;
        }
        .copy_btn{
            width: 80px;
            height: 40px;
            line-height: 40px;
            border-radius: 6px;
            background: #000;
            color: #fff;
        }
    }
    .open_web{
        font-size: 14px;
        color: #666;
        margin-top: 40px;
        span{
            color: red;
        }
    }
}
</style>